import { FC, PropsWithChildren } from 'react';

import { useApplicationConfig, useEnvironment } from '@bonusly/application';
import { useCurrentUser } from '@bonusly/who-am-i';

import { useInitTelemetry } from './hooks/use-init-telemetry';

export const TelemetryProvider: FC<PropsWithChildren> = ({ children }) => {
	const user = useCurrentUser();

	useInitTelemetry({
		applicationId: useApplicationConfig('datadogApplicationId'),
		clientToken: useApplicationConfig('datadogClientToken'),
		service: 'monarch',
		env: useEnvironment() || 'development',
		user,
	});

	return <>{children}</>;
};
